<template>
  <div class="app">
    <div class="header">
      <div class="header01">
        <div class="logo01" @click="pathIndex">
          <img :src="require('../assets/img/logo.png')" alt="名企科技logo" class="logoimg">
          <div style="display: flex;flex-direction: column;justify-content: center;">
            <div class="title">
              <span style="white-space: nowrap;">名企财务-专业财务服务机构</span>
            </div>
            <div class="des">
              <span style="white-space: nowrap;">主营:注册 记账 地址 变更 注销 许可 社保</span>
            </div>
          </div>
        </div>
        <div v-if="!isMobile" class="tel">
          <div class="title">服务热线:<a href="tel:13910303798" style="text-decoration: none;"><span class="num">1391 0303 798</span></a></div>
        </div>
        <div v-else class="tel">
            <div class="title">服务&nbsp;<br>热线:</div>
            <a href="tel:13910303798" style="text-decoration: none;"><span class="num">&nbsp;1391 0303 798</span>
          </a>
        </div>
      </div>
    </div>

    <div v-if="!isMobile" class="container">
      <div>
        <button class="allService" @click="toggleData($event)">全部服务<i class="el-icon-s-operation"
            style="margin-left:5px"></i></button>
        <div class="containerbutton" v-if="$root.showData.showData">
          <table style="background-color:white">
            <tbody>
              <tr v-for="(category, index) in dataList" :key="index">
                <td class="indextdCss">{{ category }}</td>
                <td class="indextdCSS" v-for="(detail, detailIndex) in itemData[index]" :key="detailIndex"
                  @click="handleCellClick(detail)">
                  {{ detail }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <el-menu :default-active="activeIndex" class="el-menu-index" mode="horizontal" @select="handleSelect"
        background-color="#000000" text-color="#ffffff" active-text-color="#ffffff">
        <el-menu-item index="1" @click="pathIndex">首页</el-menu-item>
        <el-menu-item index="2" @click="pathRemen">热门服务</el-menu-item>
        <el-menu-item index="3" @click="pathJizhang">代理记账</el-menu-item>
        <el-menu-item index="4" @click="pathgongshang">工商服务</el-menu-item>
        <el-menu-item index="5" @click="pathshuiwu">税务服务</el-menu-item>
        <el-menu-item index="6" @click="pathzhichan">知识产权</el-menu-item>
        <el-menu-item index="7" @click="pathxuke">资质许可</el-menu-item>
        <el-menu-item index="8" @click="pathrenshi">人事社保</el-menu-item>
        <el-menu-item index="9" @click="pathxueyuan">老板学院</el-menu-item>
        <el-menu-item index="1-1" @click="pathabout">关于我们</el-menu-item>
        <el-menu-item index="1-2" @click="pathcontact">联系我们</el-menu-item>
      </el-menu>
    </div>

    <div v-else class="container">
      <div style="display:flex;flex-direction: column;">
        <div style="display:flex;">
          <div>
            <button class="allService" @click="toggleData($event)">全部服务<i class="el-icon-s-operation"
                style="margin-left:5px"></i></button>
            <div class="containerbutton" v-if="$root.showData.showData">
              <table style="background-color:white">
                <tbody>
                  <tr v-for="(category, index) in dataList" :key="index">
                    <td class="indextdCss">{{ category }}</td>
                    <td class="indextdCSS" v-for="(detail, detailIndex) in itemData[index]" :key="detailIndex"
                      @click="handleCellClick(detail)">
                      {{ detail }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <el-menu :default-active="activeIndex" class="el-menu-index" mode="horizontal" @select="handleSelect"
            background-color="#000000" text-color="#ffffff" active-text-color="#ffffff">
            <el-menu-item index="1" @click="pathIndex">&nbsp;首&nbsp;&nbsp;页&nbsp;</el-menu-item>
            <el-menu-item index="2" @click="pathRemen">热门服务&nbsp;</el-menu-item>
            <el-menu-item index="3" @click="pathJizhang">代理记账&nbsp;</el-menu-item>
            <el-menu-item index="4" @click="pathgongshang">工商服务&nbsp;</el-menu-item>
            <el-menu-item index="5" @click="pathshuiwu">税务服务&nbsp;</el-menu-item>
          </el-menu>
        </div>

        <el-menu :default-active="activeIndex" class="el-menu-index" mode="horizontal" @select="handleSelect"
          background-color="#000000" text-color="#ffffff" active-text-color="#ffffff">
          <el-menu-item index="6" @click="pathzhichan">&nbsp;&nbsp;知识产权&nbsp;</el-menu-item>
          <el-menu-item index="7" @click="pathxuke">&nbsp;资质许可&nbsp;</el-menu-item>
          <el-menu-item index="8" @click="pathrenshi">&nbsp;人事社保&nbsp;</el-menu-item>
          <el-menu-item index="9" @click="pathxueyuan">&nbsp;老板学院&nbsp;</el-menu-item>
          <el-menu-item index="1-1" @click="pathabout">&nbsp;关于我们&nbsp;</el-menu-item>
          <el-menu-item index="1-2" @click="pathcontact">&nbsp;联系我们&nbsp;</el-menu-item>
        </el-menu>
      </div>
    </div>

    <!-- 浮窗 -->
    <div v-if="!isMobile" class="popup">
      <div class="close-btn" @click="pppopco">
        <i v-if="$root.ppp.ppp" class="el-icon-circle-close"></i>
        <i v-else class="el-icon-arrow-up"></i>
      </div>
      <div v-show="$root.ppp.ppp">
        <div class="kongxi1"><span>• </span>工商注册</div>
        <div class="kongxi"><span>• </span>代理记账</div>
        <div class="kongxi"><span>• </span>减资变更</div>
        <div class="kongxi"><span>• </span>清算注销</div>
        <div class="kongxi"><span>• </span>知识产权</div>
        <div class="kongxi"><span>• </span>资质许可</div>
        <div class="kongxi"><span>• </span>人事社保</div>
      </div>

      <a href="tel:13910303798" style="text-decoration: none;color: white;"><div class="dianhuahao">1391 0303 798</div></a>

      <div>
        <img src="../assets/img/wx.png" alt="联系我们的微信二维码">
      </div>
      <div class="saoma">微信扫码咨询</div>
    </div>
    <div v-else class="popup">
      <div class="kongxi1">马上咨询</div>
      <a href="tel:13910303798" style="text-decoration: none;color: white;"><div class="dianhuahao">1391 0303 798</div></a>
      <div>
        <img src="../assets/img/wx.png" alt="联系我们的微信二维码">
      </div>
      <div class="saoma">微信扫码咨询</div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'Header',
  props: {
    activeIndex: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pppclose: true,
      dataList: ['公司注册', '记账报税', '人事服务', '配套服务', '资质许可', '变更减资', '注销清算', '知识产权'],
      itemData: [
        ['有限公司注册', '个体工商户注册', '外资公司注册', '刻章', '银行开户'],
        ['小规模代理记账', '一般纳税人代理记账', '外资代理记账', '高新代理记账', '税务报到', '汇算清缴', '出口退税'],
        ['社保开户', '社保增员、减员', '社保扣费', '社保基数核定', '异地就医备案', '退休代办', '公积金开户', '公积金增员、减员'],
        ['税控托管', '发票托管', '审计报告咨询', '解除地址异常', '解除税务异常', '发票增量', '统计数据申报'],
        ['电信增值业务许可', '演出经纪许可', '餐饮食品许可', '图书批发、零售许可', '医疗器械许可', '道路运输许可', '进出口权许可', '体系认证'],
        ['名称变更', '经营范围变更', '股东股权变更', '法人变更', '注册地址变更', '提供注册地址', '增资减资'],
        ['公司注销', '工商注销', '对公账户注销', '社保注销', '公积金注销'],
        ['商标注册', '商标变更', '软件著作权申请', '高新申请'],
      ],
      isMobile: true,
    }
  },
  mounted() {
    this.$root.showData.showData = false;
    document.addEventListener('click', this.handleGlobalClick);
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize); // 监听窗口大小变化
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    document.removeEventListener('click', this.handleGlobalClick);
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    handleGlobalClick() {
      if (this.$root.showData.showData) {
        console.log('点击了按钮以外的区域');
        this.$root.showData.showData = false
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    toggleData(event) {
      event.stopPropagation();
      this.$root.showData.showData = !this.$root.showData.showData
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    handleCellClick(detail) {
      console.log(detail);
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>
  
<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
  }

}
</style>
  
  
<style scoped>
/* header部分的样式 */
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 998;
  height: 70px;
  background-color: #ffffff;
}

.header01 {
  width: 95%;
  margin: 0 auto;
  height: 70px;
}

.logoimg {
  height: 63px;
  width: 62px;
}

.header .logo01 {
  float: left;
  display: flex;
  justify-content: center;
}

.logo01 .title {
  text-align: left;
  font-weight: 700;
  font-size: 23px;
}

.logo01 .des {
  text-align: left;
  font-weight: 600;
  font-size: 15px;
}

.header .tel {
  display: flex;
  float: right;
  height: 70px;
  color: #3a3f47;
  align-items: center;
  justify-content: center;
}

.header .tel .title {
  font-size: 23px;
  margin-right: 10px;
  font-weight: 700;
}

.header .tel .num {
  font-size: 35px;
  color: #cf0606;
  font-family: Impact;
  margin-left: 5px;
}

.header .tel .img {
  height: 23px;
  width: auto;
}

/* 导航栏+全部服务部分的样式 */
.container {
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 998;
  background-color: black;
  margin-top: 62px;
}

.allService {
  height: 45px;
  font-size: 15px;
  background-color: #b30101;
  color: #ffffff;
  border: 1px solid #b30101;
  border-bottom: 2px solid white;
  width: 160px;
  font-weight: 900;
}

.containerbutton {
  position: absolute;
  z-index: 9999;
}

.indextdCss {
  font-size: 15px;
  padding: 6px;
  color: white;
  background-color: #c9746a;
}

.indextdCSS {
  font-size: 15px;
  padding: 6px;
  text-align: left;
}

.el-menu-index {
  margin-left: 3vh;
}

.el-menu-item {
  font-size: 15px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  cursor: pointer;
  font-weight: 900;
}


/* 浮窗的样式 */
.popup {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background-color: #d22525;
  padding: 15px;
  box-shadow: 0 0 10px rgb(0, 0, 0, 0.4);
  z-index: 1000;
  width: auto;
  height: auto;
  font-size: 17px;
  color: white;
  /* font-family: 'simhei', sans-serif; */
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-weight: 600;
}

.close-btn {
  text-align: right;
  margin-top: -13px;
  margin-right: -11px;
}

.kongxi1 .kongxi span {
  vertical-align: 10px;
}

.kongxi1 {
  padding: 2px;
}

.kongxi {
  padding: 2px;
}

.dianhuahao {
  padding: 4px;
  font-size: 15px;
  font-weight: 900;
  /* font-family: 'simhei', sans-serif; */
  font-family: Impact;
  transform: scaleX(1.2) scaleY(1.4);
  margin-bottom: 4px;
}

.saoma {
  font-size: 10px;
}

.popup img {
  width: 107px;
  height: 107px;
}

@media (max-width: 768px) {

  /* header 部分 */
  .header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 998;
    height: 38px;
    background-color: #ffffff;
  }

  .header01 {
    width: 100%;
    margin: 0 auto;
    height: 38px;
    display:flex;
    justify-content: space-between;
  }

  .header .logo01 {
    float: left;
    margin-top: 3px;
  }

  .logo01 .title {
    text-align: left;
    font-weight: 700;
    font-size: 12px;
  }

  .logo01 .des {
    text-align: left;
    font-weight: 500;
    font-size: 8px;
  }

  .logoimg {
    height: 31px;
    width: auto;
  }

  .header .tel {
    display: flex;
    float: right;
    font-size: 12px;
    color: #3a3f47;
    background-size: 25px 22px;
    margin-top: 1px;
    line-height: 14px;
    margin-right: 7px;
    /* padding-left: 3px; */
    height: 38px !important;
  }

  .header .tel .title {
    font-size: 11px;
    margin-right: 0px;
    line-height:13px;
  }

  .header .tel .img {
    height: 15px;
  }

  .header .tel .num {
    font-size: 15px;
    color: #cf0606;
    font-weight: 700;
    margin-left:0px;
  }

  /* 导航栏+全部服务 */
  .container {
    position: absolute;
    margin-top: 30px;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 998;
    background-color: black;
    flex-direction: column;
  }

  .allService {
    font-size: 10px;
    background-color: #b30101;
    border-bottom: 2px solid white;
    color: #ffffff;
    margin-right: 10px;
    margin-top: 0;
    height: 30px;
    width: auto;
  }

  .containerbutton {
    position: absolute;
    z-index: 9999;
  }

  .indextdCss {
    font-size: xx-small;
    color: white;
    padding: 1px;
    background-color: #c9746a;
  }

  .indextdCSS {
    font-size: xx-small;
    text-align: left;
    padding: 1px;
    cursor: pointer;
  }

  .el-menu-index {
    margin-left: 0;
    line-height: 30px !important;
  }

  .el-menu-item {
    font-size: 10px !important;
    display: inline-block;
    vertical-align: middle;
    padding: 2px !important;
    margin: 0;
    height: 30px !important;
    line-height: 30px !important;
  }


  /* 浮窗 */
  .popup {
    position: fixed;
    top: 50%;
    right: 5px !important;
    transform: translateY(-50%);
    background-color: #d22525;
    padding: 1px !important;
    box-shadow: 0 0 10px rgb(0, 0, 0, 0.4);
    z-index: 1000;
    width: auto;
    height: auto;
    font-size: 7px !important;
    color: white;
    font-weight:700;
  }

  .close-btn {
    text-align: right;
    margin-top: -2px;
    margin-right: -1px;
  }

  .popup span {
    font-size: 9.5px;
  }

  .kongxi1 {
    padding-top: 3px;
    font-size: 8px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .kongxi {
    padding: 1px;
  }

  .dianhuahao {
    padding: 1px;
    font-size: 12px;
    font-weight: 700;
    font-family: Impact;
    transform: scaleX(1) scaleY(1);
    margin-bottom: 0px;
  }

  .saoma {
    font-size: 8px;
    padding-bottom: 3px;
    padding-top:1px;
  }

  .popup img {
    width: 53.5px !important;
    height: 53.5px !important;
    padding-left: 1px;
    padding-right: 1px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Header.vue